import FieldsFactory from 'components/form/FieldsFactory'
import FormActionBar from 'components/form/FormActionBar'
import {Formik} from 'formik'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext} from 'react'
import {NullAsDefault, shallowDiff} from 'views/Shared'
import {Pure} from "../../../../components/Pure";
import {createControlledFormField} from "../../factory/createFormField";
import {createValue} from "../../../../components/form/utils";
import TextArea from "antd/lib/input/TextArea";
import {compose, fromRenderProps, mapProps, pure} from "recompose";
import withTranslate from "../../../../modules/local/withTranslate";
import {SelectWidget} from "../../custom/ReactSelectComponents";
import {FeedbackCategoryAsyncWrapper} from "./FeedbackCategoryAsyncWrapper";
import getTitle from "../../../../helpers/getTitle";
import getAvatar from "../../../../helpers/getAvatar";
import {getId, getType} from "../../../../apis/model/base";
import {Avatar, Input, Radio, Select} from "antd";
import {HeaderWithIconLine} from "../../Templates/items/ListHeader";
import {deepTranslate, renderIf} from "../../../Shared";
import {BsPersonFill} from "react-icons/bs";
import {Link} from "react-router-dom";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import {ItemInformation} from 'components/common/ItemInformation'
import {appFieldTypes, StatusTypes} from "../../appFieldTypes";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {GoDotFill} from "react-icons/go";
import classNames from "classnames";
import {LoginContext} from "../../../../components/LoginContext";
import {ProfileCompact} from "../../Profile/functions/renderProfile";
import {ChurchItemCompact} from "../../Church/functions/renderChurch";
import {PiMusicNotesFill} from "react-icons/pi";
import {FaBookBible} from "react-icons/fa6";
import {formatDate} from "../../../../helpers/datetimeHelpers";


const formSchema = {
    feedback_category: {
        title: 'your issue is',
        children: [
            {
                name: 'feedback_category_id',
                component: compose(
                    withTranslate,
                    fromRenderProps(FeedbackCategoryAsyncWrapper, ({items, isLoading}) => {
                        const options = Array.from(items).map((option) => {
                            return {
                                value: getId(option),
                                label: getTitle(option),
                            }
                        })
                        return ({options})
                    }),
                    mapProps(({name, value, translate, onChange, options}) => {
                        return {
                            name,
                            value,
                            allowClear: true,
                            className: 'w-full',
                            placeholder: translate('click to select'),
                            options: options,
                            onChange: (value) => {
                                onChange(createValue(name, value))
                            },
                        }
                    }),
                    pure
                )(SelectWidget),
            },
        ],
    },
    title: {
        title: 'title',
        className: '333-777',
        children: [
            {
                name: 'title',
                component: createControlledFormField({
                    placeholder: 'title',
                }),
            },
        ],
    },
    description: {
        title: 'description',
        children: [
            {
                name: 'description',
                component: createControlledFormField({
                    placeholder: 'description',
                    className: 'scrollBarThin custom-area-count',
                    Component: TextArea,
                    showCount: true,
                    maxLength: 1000,
                    autoSize: {minRows: 3, maxRows: 6},
                }),
            },
        ],
    },
    name: {
        title: 'full name',
        children: [
            {
                name: 'name',
                component: createControlledFormField({
                    placeholder: 'full name',
                    withValues: ({login}) => {
                        return ({
                            disabled: !!login?.name,
                        })
                    },
                }),
            },
        ],
    },
    phone_email: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-3 gap-3',
        itemClassNames: ['col-span-1', 'col-span-1 md:col-span-2'],
        children: [
            {
                label: 'phone',
                name: 'phone',
                component: createControlledFormField({
                    type: 'tel',
                    placeholder: 'phone',
                    withValues: ({login}) => ({
                        disabled: !!login?.phone_number,
                    }),
                }),
            },
            {
                label: 'email',
                name: 'email',
                component: createControlledFormField({
                    type: 'email',
                    placeholder: 'email',
                    withValues: ({login}) => ({
                        disabled: !!login?.email,
                    }),
                }),
            },
        ],
    },

    reply_title: {
        title: 'response title',
        children: [
            {
                name: 'reply_title',
                component: createControlledFormField({
                    placeholder: 'response title',
                }),
            },
        ],
    },
    reply_description: {
        title: 'response content',
        children: [
            {
                name: 'reply_description',
                component: createControlledFormField({
                    placeholder: 'response content',
                    className: 'scrollBarThin custom-area-count',
                    Component: TextArea,
                    showCount: true,
                    maxLength: 1000,
                    autoSize: {minRows: 3, maxRows: 6},
                }),
            },
        ],
    },
    status: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-2 gap-3',
        children: [
            {
                label: 'status',
                name: 'status',
                component: ({name, value, form, onChange}) => {
                    const options = Array.from(form?.values?.status_options ?? [])
                    return (
                        <Radio.Group
                            name={name}
                            value={value}
                            options={options}
                            onChange={onChange}
                            optionType="button"
                            buttonStyle="solid"
                            className="custom-radio-button"
                        />
                    )
                },
            },
            {
                label: 'public',
                name: 'public',
                component: ({name, value, form, onChange}) => {
                    const options = Array.from(form?.values?.public_options ?? [])
                    return (
                        <Radio.Group
                            name={name}
                            value={value}
                            options={options}
                            onChange={onChange}
                            optionType="button"
                            buttonStyle="solid"
                            className="custom-radio-button"
                        />
                    )
                },
            },
        ],
    },

}

export const DetailForm = ({item, onCancel}) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)

    const {
        title,
        description,
        user,
        phone,
        email,
        name,
        feedback_category,
        created,
        ref,
        reply_title,
        reply_description,
        status,
        updated,
    } = item ?? {}

    const ItemContent = ({inline = false, showIcon = false, label, value, fontSize = 'text-sm', textClass = 'text-color-100'}) => (
        <div className={classNames('', fontSize, inline === true ? 'space-x-1' : 'flex flex-col')}>
            {renderIf(
                showIcon === true,
                <GoDotFill size={10} className="text-color-400"/>
            )}
            <span className="text-color-400 italic">{`${t(label)} : `}</span>
            <span className={classNames("", textClass, inline === false && 'ml-3')}>
                {value}
            </span>
        </div>
    )

    const renderSender = () => {
        if (user) {
            return (
                <div className="ml-4 flex items-center gap-2">
                    <Avatar
                        size={26}
                        icon={<BsPersonFill size={16} className="text-color-500"/>}
                        src={user?.avatar}
                        className="flex flex-center background-200"
                    />
                    <Link to={getLinkToDetail(user)}
                          className="flex-1 font-semibold text-sm text-color-100 no-underline leading-tight">
                        {user?.name}
                    </Link>
                </div>
            )
        } else if (name) {
            return (
                <div className="ml-4 flex flex-col gap-1 flex-1">
                    <ItemInformation label="full name" value={name} className="text-sm"/>
                    <div className="flex items-center gap-6">
                        <ItemInformation label="phone" value={phone} className="text-sm"/>
                        <ItemInformation label="email" value={email} className="text-sm"/>
                    </div>
                </div>
            )
        }
        return (
            <div className="flex items-center gap-3">
                <GoDotFill size={10} className="text-color-400"/>
                <span className="font-medium text-xs text-color-300 leading-tight">
                    {`${t('anonymous user')} *`}
                </span>
            </div>
        )
    }

    const renderRef = (ref) => {

        let _itemRender

        switch (getType(ref)) {
            case 'church':
                _itemRender = <ChurchItemCompact item={ref}/>
                break
            case 'profile':
                _itemRender = <ProfileCompact item={ref}/>
                break
            case 'codi_document':
                const {document_type, language} = ref ?? {}
                _itemRender = (
                    <div className="flex items-center gap-3 custom-render-border rounded-lg relative">
                        <Avatar
                            size={60}
                            icon={<FaBookBible size={30} className="text-primary-400"/>}
                            className="flex flex-center bg-primary-50 rounded-l-lg rounded-r-0"
                        />
                        <div className="py-1 flex flex-col flex-1">
                            <Link to={getLinkToDetail(ref)} target="_blank" className="font-bold text-color-000 no-underline leading-snug mb-1">
                                {getTitle(ref)}
                            </Link>
                            <div className="flex items-center gap-x-2 md:gap-x-6">
                                <div className="flex items-baseline gap-1 leading-tight">
                                    <span className="text-xs text-color-500 italic">{`${t('document type')} : `}</span>
                                    <span className="font-medium text-xs text-blue-500 italic">
                                        {document_type?.title}
                                    </span>
                                </div>
                                <ItemInformation label="language" value={t(language)} className="text-xs" />
                            </div>
                        </div>
                        <span
                            style={{ height: 20, fontSize: 10, padding: '0 10px'}}
                            className="absolute right-5 flex flex-center bg-orange-50 rounded-full font-medium text-orange-500 italic leading-tight">
                            {t(getType(ref))}
                        </span>
                    </div>
                )
                break
            case 'music':
                const {music_authors = [], music_types = []} = ref ?? {}
                _itemRender = (
                    <div className="flex items-center gap-3 custom-render-border rounded-lg relative">
                        <Avatar
                            size={60}
                            icon={<PiMusicNotesFill size={30} className="text-primary-400"/>}
                            className="flex flex-center bg-primary-50 rounded-l-lg rounded-r-0"
                        />
                        <div className="py-1 flex flex-col flex-1">
                            <Link to={getLinkToDetail(ref)} target="_blank" className="font-bold text-color-000 no-underline leading-snug">
                                {getTitle(ref)}
                            </Link>
                            {renderIf(
                                music_authors.length > 0,
                                <div className="flex items-baseline gap-1 leading-tight">
                                    <span className="text-xs text-color-500 italic">{`${t('author')} : `}</span>
                                    {music_authors.map((e, i) => (
                                        <span key={i} className="font-medium text-xs text-color-100 italic">
                                            {e.fullname} {i < music_authors.length - 1 && ' - '}
                                        </span>
                                    ))}
                                </div>
                            )}
                            {renderIf(
                                music_types.length > 0,
                                <div className="flex items-baseline gap-1 leading-tight">
                                    <span className="text-xs text-color-500 italic">{`${t('music types')} : `}</span>
                                    {music_types.map((e, i) => (
                                        <span key={i} className="font-medium text-xs text-blue-500 italic">
                                            {e.title} {i < music_types.length - 1 && ' - '}
                                        </span>
                                    ))}
                                </div>
                            )}
                        </div>
                        <span
                            style={{ height: 20, fontSize: 10, padding: '0 10px'}}
                            className="absolute right-5 flex flex-center bg-orange-50 rounded-full font-medium text-orange-500 italic leading-tight">
                            {t(getType(ref))}
                        </span>
                    </div>
                )
                break
            default:
                const {description, container, owner} = ref ?? {}
                _itemRender = (
                    <div className="p-2 flex items-center gap-3 custom-render-border relative">
                        <div className="flex flex-col flex-1">
                            <Link to={getLinkToDetail(ref)} target="_blank" className="font-bold text-color-000 no-underline leading-snug mb-1">
                                {description}
                            </Link>
                            <div className="flex items-baseline gap-x-1 text-xs text-color-500 italic">
                                <Link to={getLinkToDetail(owner)} className="font-bold text-color-100 no-underline">
                                    {getTitle(owner)}
                                </Link>
                                <span className="whitespace-no-wrap">{t('posted on channel')}</span>
                                <Link to={getLinkToDetail(container)} className="font-semibold text-green-600 no-underline">
                                    {getTitle(container)}
                                </Link>
                            </div>
                        </div>
                        <span
                            style={{ height: 20, fontSize: 10, padding: '0 10px'}}
                            className="absolute right-5 flex flex-center bg-orange-50 rounded-full font-medium text-orange-500 italic capitalize leading-tight">
                            {t(getType(ref))}
                        </span>
                    </div>
                )
                break

        }
        return _itemRender
    }

    return (
        <div className="flex flex-col gap-6">
            {renderIf(
                ref,
                renderRef(ref)
            )}
            <div className="flex flex-col gap-2">
                <HeaderWithIconLine
                    icon={ <GoDotFill size={14} className="text-color-500" /> }
                    title="content"
                    className="text-color-300"
                />
                <div className="ml-3 flex flex-col gap-2">
                    <ItemContent label="header" value={title} textClass="font-semibold text-color-000"/>
                    <ItemContent label="description" value={description} textClass="font-normal text-color-300"/>
                    <ItemContent
                        inline={true}
                        showIcon={true}
                        fontSize="text-xs"
                        label="category"
                        value={feedback_category?.title}
                        textClass="font-medium text-blue-500"
                    />
                    <ItemContent
                        inline={true}
                        showIcon={true}
                        fontSize="text-xs"
                        label="send at"
                        value={formatDate(created, 'HH:mm - DD/MM/YYYY')}
                        textClass="font-medium text-color-000 italic"
                    />
                    <div className="flex flex-col gap-1 text-xs">
                        {renderIf(
                            _.some([user, name]),
                            <div className="space-x-1">
                                <GoDotFill size={10} className="text-color-400"/>
                                <span className="text-color-400 italic">{`${t('creator')} : `}</span>
                            </div>
                        )}
                        {renderSender()}
                    </div>
                </div>
            </div>
            {renderIf(
                _.some([reply_title, reply_description]),
                <div className="flex flex-col gap-2">
                    <HeaderWithIconLine
                        icon={ <GoDotFill size={10} className="text-color-400" /> }
                        title="responses"
                        className="text-sm text-color-400"
                    />
                    <div className="ml-3 flex flex-col gap-2">
                        <ItemContent inline={true} label="header" value={reply_title}
                                     textClass="font-semibold text-color-000"/>
                        <ItemContent label="description" value={reply_description}
                                     textClass="font-normal text-color-300"/>
                        <ItemContent
                            showIcon={true}
                            inline={true}
                            fontSize="text-xs"
                            label="responses at"
                            value={formatDate(updated, 'HH:mm - DD/MM/YYYY')}
                            textClass="font-medium text-color-100 italic"
                        />
                    </div>
                </div>
            )}
            <div className="flex justify-end p-3 mt-6">
                <span onClick={onCancel} className="font-medium text-color-200 hover:text-color-000 cursor-pointer">
                    {t('close')}
                </span>
            </div>
        </div>
    )
}

export const CreateFeedbackForm = ({
    className = '',
    initValues = {},
    onCancel = NullAsDefault,
    onSubmit = NullAsDefault,
}) => {
    const t = useTranslate()
    const login = useContext(LoginContext)

    const initialValues = {
        login,
        feedback_category_id: undefined,
        title: undefined,
        description: undefined,
        name: login?.name,
        email: login?.email,
        phone: login?.phone_number,
        ...initValues,
    }

    const validate = (values) => {
        const errors = {}
        if (!values.title?.trim()) errors.title = t('required field')
        if (!values.description?.trim()) errors.description = t('required field')
        return errors
    }

    return (
        <Formik
            initialValues={initialValues}
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            onSubmit={(values) => {
                onSubmit(_.omitBy(values, _.isUndefined))
            }}>
            {({values, errors, touched, setFieldValue, submitForm, isValid, isSubmitting}) => (
                <div className="flex flex-col gap-4">

                    {/* Category */}
                    <div className="flex flex-col gap-1.5">
                        <span className="text-xs font-semibold text-color-300 uppercase tracking-wider">
                            {t('your issue is')}
                        </span>
                        <Pure>
                            <FeedbackCategoryAsyncWrapper>
                                {({items, isLoading, onSearch}) => (
                                    <Select
                                        value={values.feedback_category_id}
                                        onChange={(v) => setFieldValue('feedback_category_id', v)}
                                        onSearch={onSearch}
                                        showSearch
                                        filterOption={false}
                                        loading={isLoading}
                                        allowClear
                                        placeholder={t('click to select')}
                                        className="w-full"
                                        options={items.map(i => ({value: getId(i), label: getTitle(i)}))}
                                    />
                                )}
                            </FeedbackCategoryAsyncWrapper>
                        </Pure>
                    </div>

                    {/* Title */}
                    <div className="flex flex-col gap-1.5">
                        <span className="text-xs font-semibold text-color-300 uppercase tracking-wider">
                            {t('title')} <span className="text-red-400 font-normal normal-case">*</span>
                        </span>
                        <Input
                            value={values.title}
                            onChange={(e) => setFieldValue('title', e.target.value)}
                            placeholder={t('title')}
                            status={touched.title && errors.title ? 'error' : ''}
                            className="rounded-xl"
                            allowClear
                        />
                        {touched.title && errors.title && (
                            <span className="text-xs text-red-500">{errors.title}</span>
                        )}
                    </div>

                    {/* Description */}
                    <div className="flex flex-col gap-1.5">
                        <span className="text-xs font-semibold text-color-300 uppercase tracking-wider">
                            {t('description')} <span className="text-red-400 font-normal normal-case">*</span>
                        </span>
                        <TextArea
                            value={values.description}
                            onChange={(e) => setFieldValue('description', e.target.value)}
                            placeholder={t('description')}
                            autoSize={{minRows: 3, maxRows: 6}}
                            maxLength={1000}
                            showCount
                            status={touched.description && errors.description ? 'error' : ''}
                            className="scrollBarThin custom-area-count"
                        />
                        {touched.description && errors.description && (
                            <span className="text-xs text-red-500">{errors.description}</span>
                        )}
                    </div>

                    {/* Sender info */}
                    {login ? (
                        <div className="flex items-center gap-3 px-3 py-2.5 background-50 rounded-xl border border-color-50">
                            <Avatar
                                size={34}
                                src={getAvatar(login)}
                                icon={<BsPersonFill size={16} className="text-color-400"/>}
                                className="flex flex-center background-200 flex-shrink-0"
                            />
                            <div className="flex flex-col gap-0.5 flex-1 min-w-0">
                                <span className="font-semibold text-sm text-color-000 leading-none truncate">
                                    {login?.name}
                                </span>
                                <span className="text-xs text-color-400 italic truncate">
                                    {login?.email || login?.phone_number}
                                </span>
                            </div>
                            <span
                                style={{padding: '2px 8px'}}
                                className="flex-shrink-0 text-2xs font-semibold text-green-600 bg-green-50 rounded-full">
                                ✓ {t('logged in')}
                            </span>
                        </div>
                    ) : (
                        <div className="flex flex-col gap-3">
                            <span className="text-xs font-semibold text-color-300 uppercase tracking-wider">
                                {t('information sender')}
                            </span>
                            <Input
                                value={values.name}
                                onChange={(e) => setFieldValue('name', e.target.value)}
                                placeholder={t('full name')}
                                className="rounded-xl"
                            />
                            <div className="grid grid-cols-2 gap-2">
                                <Input
                                    value={values.phone}
                                    onChange={(e) => setFieldValue('phone', e.target.value)}
                                    placeholder={t('phone')}
                                    type="tel"
                                    className="rounded-xl"
                                />
                                <Input
                                    value={values.email}
                                    onChange={(e) => setFieldValue('email', e.target.value)}
                                    placeholder={t('email')}
                                    type="email"
                                    className="rounded-xl"
                                />
                            </div>
                        </div>
                    )}

                    {/* Thank you */}
                    <p className="text-xs text-color-400 italic text-center leading-relaxed">
                        {t('report description thank')}
                    </p>

                    {/* Actions */}
                    <div className="flex items-center gap-3">
                        <button
                            type="button"
                            onClick={onCancel}
                            className="flex-1 py-2.5 rounded-xl text-sm font-semibold text-color-300 background-100 hover:background-200 transition-colors cursor-pointer border-0">
                            {t('cancel')}
                        </button>
                        <button
                            type="button"
                            onClick={submitForm}
                            disabled={!isValid || isSubmitting}
                            className={classNames(
                                'flex-1 py-2.5 rounded-xl text-sm font-bold transition-all cursor-pointer border-0',
                                isValid && !isSubmitting
                                    ? 'bg-primary text-white hover:opacity-90 shadow-sm'
                                    : 'bg-color-100 text-color-400 cursor-not-allowed'
                            )}>
                            {t('submit')}
                        </button>
                    </div>
                </div>
            )}
        </Formik>
    )
}

export const EditFeedbackForm = ({
    item,
    initialValues,
    onCancel = NullAsDefault,
    onSubmit = NullAsDefault,
}) => {
    const t = useTranslate();
    const status_options = [StatusTypes.PENDING__1, StatusTypes.CLOSED]

    const {feedback_category} = initialValues ?? {}

    const _initialValues = {
        ...initialValues,
        feedback_category_id: getId(initialValues?.feedback_category),
        status_options: status_options.map(deepTranslate(t)),
        public_options: appFieldTypes.yesOrno.map(deepTranslate(t))
    }
    const validate = (values) => {
        let errors = {}
        _.forEach(['title', 'description'], (name) => {
            const value = _.get(values, name)
            if (_.isEmpty(value ?? undefined)) {
                errors[name] = t('required field')
            }
        })
        return errors
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={_initialValues}
            onPreSubmit={({...values}) => {
                const changes = shallowDiff(values, _initialValues)
                return _.omitBy(
                    {
                        ...changes
                    },
                    _.isUndefined
                )
            }}
            onSubmit={({...values}) => {
                const changes = shallowDiff(values, initialValues)
                onSubmit(_.omitBy(
                    {
                        ...changes,
                    },
                    _.isUndefined
                ))
            }}>
            <div className="flex flex-col gap-3">
                <div className="flex flex-col gap-2">
                    <HeaderWithIconLine
                        className="mt-3"
                        renderTitle={() => (
                            <div className="flex items-center gap-3">
                                <GoDotFill size={16} className="text-color-500"/>
                                <span className="font-bold text-lg text-color-300 uppercase leading-snug tracking-wider">
                                    {t('content feedback')}
                                </span>
                            </div>
                        )}
                    />
                    <div className="ml-5 space-y-3">
                        <Pure>
                            <FieldsFactory
                                formSchema={[
                                    formSchema.feedback_category,
                                    formSchema.title,
                                    formSchema.description,
                                ]}
                            />
                        </Pure>
                    </div>
                </div>
                <div className="flex flex-col gap-2">
                    <HeaderWithIconLine
                        className="mt-3"
                        renderTitle={() => (
                            <div className="flex items-center gap-3">
                                <GoDotFill size={16} className="text-color-500"/>
                                <span
                                    className="font-bold text-lg text-color-300 uppercase leading-snug tracking-wider">
                    {t('responses')}
                </span>
                            </div>
                        )}
                    />
                    <div className="ml-5 space-y-3">
                        <Pure>
                            <FieldsFactory
                                formSchema={[
                                    formSchema.reply_title,
                                    formSchema.reply_description,
                                ]}
                            />
                        </Pure>
                        <Pure>
                            <FieldsFactory
                                formSchema={[
                                    formSchema.status,
                                ]}
                            />
                        </Pure>
                    </div>
                </div>
                <FormActionBar submitText="responses"/>
            </div>
        </Formik>
    )
}


